import { Skeleton } from '@/core/ui/atoms/skeleton'

export function TermsSkeleton() {
  return (
    <div className=''>
      <div className='flex flex-col gap-1'>
        <Skeleton width='1200px' height='38px' borderRadius='0.375rem' />
        <Skeleton width='1200px' height='38px' borderRadius='0.375rem' />
        <Skeleton width='1200px' height='38px' borderRadius='0.375rem' />
        <Skeleton width='1200px' height='38px' borderRadius='0.375rem' />
        <Skeleton width='1200px' height='38px' borderRadius='0.375rem' />
      </div>
    </div>
  )
}
